import { render, staticRenderFns } from "./createStory.vue?vue&type=template&id=5789b307&scoped=true&"
import script from "./createStory.vue?vue&type=script&lang=js&"
export * from "./createStory.vue?vue&type=script&lang=js&"
import style0 from "./createStory.vue?vue&type=style&index=0&id=5789b307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789b307",
  null
  
)

export default component.exports